import { shouldShowError } from './shouldShowError';
/**
 * Returns `true` if there is an error, and it should be shown to the user.
 * @param props - widget props
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isErrorVisible(props) {
    if (shouldShowError(props)) {
        return props.internalData.error != null || props.error != null;
    }
    else {
        return false;
    }
}
